module.exports = window.localStorage;
